import { render, staticRenderFns } from "./AlcoholUsage.vue?vue&type=template&id=bb42590e&scoped=true"
import script from "./AlcoholUsage.vue?vue&type=script&lang=js"
export * from "./AlcoholUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb42590e",
  null
  
)

export default component.exports